/**
 * Copyright 2018 Ambrosus Inc.
 * Email: tech@ambrosus.com
 */
import React, { createContext, useState, useEffect } from 'react';
import './Documentation.scss';
import { Introduction, GettingStarted, Examples } from './Sections';
import Aside from 'src/app/components/Aside';
import 'prismjs/plugins/line-numbers/prism-line-numbers';

export interface ContextInterface {
  hash: string;
  setHash: (hashValue: string) => void;
}
// tslint:disable-next-line:no-empty
export const DocumentationContext = createContext<ContextInterface>({ hash: '', setHash: () => { } });

const JavascriptSDK = () => {
  const [hash, setHash] = useState();
  const setHashValue = (hashValue: string) => {
    setHash(hashValue);
    if (history.pushState) {
      window.history.pushState(null, '', `#${hashValue}`);
    } else {
      window.location.hash = hashValue;
    }
  };

  useEffect(() => {
    const tempHash = window.location.href.split('#')[1];
    if (tempHash) {
      const current = document.getElementById(tempHash);
      setTimeout(() => {
        window.scrollTo({
          top: current!.offsetTop - 70,
        });
      });
    }
    let anchors: any = document.getElementsByClassName('AMB-Anchor');
    anchors = [...anchors];
    const getActive = () => {
      anchors.forEach((anchor: any) => {
        if (Math.abs(window.scrollY - anchor.offsetTop) <= 80) {
          if (hash !== anchor.id) {
            setHashValue(anchor.id);
            return;
          }
        }
      });
    };
    window.addEventListener('scroll', getActive);
    return () => {
      window.removeEventListener('scroll', getActive);
    };
  }, []);

  return (
    <DocumentationContext.Provider value={{ hash, setHash: setHashValue }}>
      <div className='line-numbers javascript-sdk'>
        <Aside />
        <div className='main'>
          <Introduction />
          <GettingStarted />
          <Examples />
        </div>
      </div>
    </DocumentationContext.Provider>
  );
};

export default JavascriptSDK;
